// src/jsx/components/tourSteps.ts
export interface TourStep {
  target: string;
  content: string;
  position?: string;
  group?: string;
  order?: number;
  title?: string;
  [key: string]: any; // fallback para propriedades adicionais
}

export const tourSteps = [
  {
    title: "👋 Boas-vindas ao iBox⁶!",
    content: "Aqui você acompanha seus investimentos de forma fácil e visual.",
    target: "#home", // ou o id do card específico
    placement: "bottom",
    // 0
  },
  {
    title: "🔒 Conecte seus dados da B3",
    content: "Ao conectar sua conta do iBox6 à B3, todos os seus ativos serão importados para dentro da sua conta de forma rápida, fácil e em tempo real. Tudo feito de forma segura, com autorização oficial da B3.",
    target: "#b3",
    placement: "bottom",
    // 1
  },
  {
    title: "👑 Seja um iBoxer Premium",
    content: "Assinantes Premium têm acesso à Carteira Inteligente com simulador de aporte, a relatórios completos de IR e vídeos com análise fundamentalista dos ativos.",
    target: "#premium",
    placement: "bottom",
    // 2
  },
  {
    title: "🔍 Visualização geral do seu patrimônio",
    content: "Acompanhe seus números mais importantes e crescimento patrimonial já na página inicial.",
    target: "#card-home",
    placement: "bottom",
    // 3
  },
  {
    title: "👝 Visualize sua carteira de forma inteligente",
    content: 
        "Acompanhe todos os seus ativos, veja sua distribuição e performance em um só lugar. " +
        "Dica: Use os filtros para visualizar ativos por categoria, classe ou corretora",
    target: "#bottom-wallet",
    placement: "bottom",
    // 4
  },
  {
    title: "📈 Acompanhe seus ativos",
    content: "Aqui você acompanha sua carteira em todos os detalhes: quantidade, tipo, porcentagem na carteira e objetivo",
    target: "#cart-ativos",
    placement: "bottom",
    // 5
  },
  {
    title: "Faça a sua [ANÁLISE DE ATIVOS]",
    content: 
      "Aqui você analisa resultados e gráficos, e escolhe os melhores ativos para a sua carteira. " + 
      "Dica: Conte com a ajuda do nosso ranking de ativos feitos por análise humana + IA",
    target: "#analise-ativos",
    placement: "bottom",
    // 6
  },
  {
    title: "🧭 Explore o universo de Ações e FIIs!",
    content: 
      "Analise, use filtros e compare os melhores ativos. " + 
      "Veja fatos relevantes, dados de governança e muito mais!",
    target: "#ativos",
    placement: "bottom",
    // 7
  },
  {
    title: "Acompanhe sua [RENDA PASSIVA]",
    content: 
      "Aqui você vê o quanto o seu dinheiro está trabalhando por você e te deixando cada vez mais perto da Liberdade Financeira. " + 
      "Acompanhe tudo o que já recebeu e tudo que ainda vai receber!",
    target: "#renda-passiva",
    placement: "bottom",
    // 8
  },
  {
    title: "[SIMULE] estratégias antes de investir",
    content: 
      "Use nossos simuladores para planejar seu futuro financeiro. " + 
      "Saiba quanto precisa aportar e por quanto tempo para chegar ao seu objetivo.",
    target: "#simulador",
    placement: "bottom",
    // 9
  },
  {
    title: "Simplifique seu [IMPOSTO DE RENDA]",
    content: 
      "Gere relatórios de renda variável com todos os dados que precisa para declarar seu IR. " + 
      "Tudo pronto em pouco cliques. Rápido e fácil.",
    target: "#imposto-renda",
    placement: "bottom",
    // 10
  },
  {
    title: "Aprenda com quem entende nos [CURSOS GRATUITOS]",
    content: 
      "Conhecimento liberta. Aprenda com quem já trilhou o caminho da Inteligência Financeira e dos Investimentos",
    target: "#cursos-gratuitos",
    placement: "bottom",
    // 11
  },
];


